import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';
import { EconomyService } from '../../../services/economy.service';

@Component({
  selector: 'tt-delivery-method',
  templateUrl: './delivery-method.component.html',
  styleUrls: ['./delivery-method.component.css'],
  standalone: false,
})
export class DeliveryMethodComponent implements OnInit {
    deliveryMethodNo;

    public deliveryMethodNameButtons: FormButton[] = [{ id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'deliverymethodlangs', gotoParms: () => this.edit!.deliverymethod_no ?? '' }];

    public transCarrierServicesButtons: FormButton[] = [
        {
            id: 'goto',
            type: 'primary',
            icon: 'fas fa-chevron-right',
            onClick: async () => {
                if (!!this.edit) {
                    const response = (await this.datatask.Post(391, this.edit))[0];

                    if (response?.iserror !== '1') {
                        this.modal.show({
                            type: 'warning',
                            title: 'error',
                            translateTitle: true,
                            message: response.message
                        });
                    } else {
                        this.stateService.go('deliverymethodservices', { deliverymethod_no: this.edit.deliverymethod_no });
                    }
                }
            }
        }
    ];

    public pickJobGroupButtons: FormButton[] = [{ id: 'list', type: 'primary', icon: 'fa fa-bars', goto: 'stockplaces' }];

    public pickJobGroupEditButtons: FormButton[] = [
        { id: 'erase', icon: 'fa fa-eraser', type: 'danger', onClick: () => this.edit!.pickjobgrp_keyno = '0' },
        { id: 'list', type: 'primary', icon: 'fa fa-bars', goto: 'stockplaces' }
    ];

    public edit?: Edit;

    public selectListTransCarriers: TransCarrierItem[] = [];

    public selectListTransCarrierProducts: TransCarrierProductItem[] = [];

    public selectListPickJobGroups: Item[] = [];

    public selectListReturnMethods: ReturnMethodItem[] = [];

    public selectListBusinessSites: Item[] = [];

    public saving = false;

    public deleting = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService, private economy: EconomyService) {
        this.deliveryMethodNo = this.stateService.getStateParams()['deliverymethod_no'];
    }

    private async loadEdit() {
        if (!!this.deliveryMethodNo) {
            this.edit = (await this.datatask.Post(386, { deliverymethod_no: this.deliveryMethodNo }))[0];
        }
    }

    private async loadTransCarriers() {
        this.selectListTransCarriers = await this.datatask.Post(388);
    }

    private async loadPickJobGroups() {
        this.selectListPickJobGroups = await this.datatask.Post(2165, { stockplace_id: 'ALL' });
    }

    private async loadReturnMethods() {
        this.selectListReturnMethods = await this.datatask.Post(1598);
    }

    private async loadBusinessSites() {
        this.selectListBusinessSites = await this.economy.getBusinessSites({ add_all: '1' });
    }

    private async loadTransCarrierProducts() {
        if (!this.edit) return;

        return this.selectListTransCarrierProducts = await this.datatask.Post(389, { transcarrier_keyno: this.edit.transcarrier_keyno });
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(391, this.edit))[0];

                if (response?.iserror !== '1') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.message
                    });
                } else {
                    this.stateService.go('deliverymethods');
                }
            } finally {
                this.saving = false;
            }
        }
    }

    public async deleteValues() {
        if (!!this.edit) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    await this.datatask.Post(392, { deliverymethod_no: this.edit.deliverymethod_no });

                    this.stateService.go('deliverymethods');
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    public onChanged(_: string, id: keyof Edit) {
        if (!this.edit) return;

        switch (id) {
            case 'transcarrier_keyno':
                this.loadTransCarrierProducts();
                this.edit.transcarrier_services = '';
                break;
            case 'transcarrier_product_keyno':
                this.edit.transcarrier_services = '';
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadEdit();
        this.loadTransCarriers();
        this.loadPickJobGroups();
        this.loadReturnMethods();
        this.loadBusinessSites();
        this.loadTransCarrierProducts();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    deliverymethod_no: string;
    deliverymethod_name: string;
    transcarrier_keyno: string;
    transcarrier_product_keyno: string;
    own_label: string;
    transfer_direct: string;
    returnservice: string;
    pickup: string;
    private_delivery: string;
    testmode: string;
    return_deliverymethod_no: string;
    pickjobgrp_keyno: string;
    special_treatment: string;
    requisition_delivery_to_customer: string;
    businesssite_keyno: string;
    phone: string;
    internal_driver: string;
    transcarrier_services: string;
    nbr_of_valid_for_businessco: string;
    external_customer_no: string;
    tpl_ref: string;
    tpl_product_id: string;
    tracktrace_url_after: string;
    setting_show_send_delivery_confirmation: string;
    send_delivery_confirmation: string;
}

interface TransCarrierItem {
    transcarrier_keyno: string;
    transcarrier_name: string;
    orderby: number;
}

interface TransCarrierProductItem {
    transcarrier_product_keyno: string;
    product_name: string;
    orderby: number;
}

interface ReturnMethodItem {
    deliverymethod_no: string;
    deliverymethod_name: string;
    transcarrier_keyno: string;
    transcarrier_name: string;
    orderby: number;
}
